import React from 'react'
import { Star } from 'lucide-react'

const SocialProofSection = () => {
  const testimonials = [
    {
      quote: "Finally, I can see exactly when my café is busy — and schedule staff without guesswork.",
      author: "Sarah, Local Coffee Shop Owner",
      rating: 5
    },
    {
      quote: "We cut wasted ad spend after seeing which promotions actually drove foot traffic.",
      author: "Mark, Gym Manager",
      rating: 5
    }
  ]

  return (
    <section className="section-padding bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-12">
          Trusted by local businesses like yours.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="card-shadow p-8 group hover:scale-105 transition-transform duration-200">
              <div className="flex items-center justify-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-600 mb-4 italic text-lg">
                "{testimonial.quote}"
              </p>
              <div className="font-semibold text-gray-900">{testimonial.author}</div>
            </div>
          ))}
        </div>

        <div className="text-gray-500 space-y-2">
          <p className="text-lg">100+ businesses already signed up to try.</p>
          <p className="text-sm">Built in Austin, TX.</p>
        </div>
      </div>
    </section>
  )
}

export default SocialProofSection
